// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../differenceInCalendarISOWeekYears/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var differenceInCalendarISOWeekYears = convertToFP(fn, 2);
export default differenceInCalendarISOWeekYears;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/differenceInCalendarISOWeekYears/index.js
// module id = 828
// module chunks = 0